import React from "react";
import { Text, View } from "react-native";
import FormControl from "@material-ui/core/FormControl";
import { enUS } from "./en-US.js";
import { zhHK } from "./zh-HK.js";
import { languageStorage } from "../../lib/LanguageStorage.js";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import Member from "../../Member.js";

class YesNoRadio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: {},
    };
  }

  _onChange(choice) {
    this.props.onChange(choice);
  }

  componentDidMount() {
    const getText = (language) => {
      let text = enUS;
      if (language == "zhHK") {
        text = zhHK;
      }
      return text;
    };
    languageStorage.getLanguage((language) =>
      this.setState({ text: getText(language) })
    );
  }

  render() {
    const yesText = this.props.yesLabel || this.state.text?.yes;
    const noText = this.props.noLabel || this.state.text?.no;

    const themeColor = Member.getThemeColor();
    return (
      <div>
        <View style={{ textAlign: "Center" }}>
          <Text style={this.props.questionStyle}>{this.props.question}</Text>
        </View>
        <FormControl style={styles.formControl}>
          <RadioGroup
            row
            aria-label="Gender"
            name={this.props.name || "yesNo"}
            value={this.props.choice}
            onChange={(e) => this._onChange(e.target.value)}
            style={{ justifyContent: "center" }}
          >
            <FormControlLabel
              value="Y"
              control={<Radio color="default" 
                style={{color:this.props.choice==="Y"? themeColor : undefined}}/>}
              label={yesText}
            />
            <FormControlLabel
              value="N"
              control={<Radio color="default" 
                style={{color:this.props.choice==="N"? themeColor : undefined}}/>}
              label={noText}
            />
          </RadioGroup>
        </FormControl>
      </div>
    );
  }
}

const styles = {
  RadioQuestion: {
    flex: 1,
    flexDirection: "row",
    marginTop: 10,
    marginBottom: 10,
  },

  formControl: {
    display: "block",
    marginTop: 12,
    marginBottom: 12,
  },
};

export default YesNoRadio;
